import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./BankingPartners.css";

const BankingPartnersSection = () => {
  const { bankList: banks, loading } = useSelector((state) => state.bankList);

  const [bankRows, setBankRows] = useState({
    firstRow: [],
    secondRow: [],
    thirdRow: [],
  });

  useEffect(() => {
    if (!banks || banks.length === 0) return;

    // Active banks only
    const activeBanks = banks.filter(
      (bank) =>
        bank.is_active === 1 ||
        bank.is_active === "1" ||
        bank.is_active === true,
    );

    // Shuffle banks
    const shuffledBanks = [...activeBanks].sort(() => Math.random() - 0.5);

    const perRow = Math.ceil(shuffledBanks.length / 3);

    setBankRows({
      firstRow: shuffledBanks.slice(0, perRow),
      secondRow: shuffledBanks.slice(perRow, perRow * 2),
      thirdRow: shuffledBanks.slice(perRow * 2),
    });
  }, [banks]);

  const renderBankRow = (items, rowNumber) => {
    if (!items?.length) return null;

    // Duplicate for infinite marquee
    const marqueeItems = [...items, ...items];

    return (
      <div className="partner-banks-row-wrapper" key={`row-${rowNumber}`}>
        <ul className={`partner-banks-row partner-banks-row-anim-${rowNumber}`}>
          {marqueeItems.map((bank, index) => (
            <li
              key={`${rowNumber}-${bank.id}-${index}`}
              className="partner-bank-card"
            >
              <img
                src={bank.bank_logo_url}
                alt={bank.bank_name}
                className="partner-bank-logo"
                loading="lazy"
                onError={(e) => {
                  e.target.src = `/bank-logos/${bank.bank_name
                    .toLowerCase()
                    .replace(/\s+/g, "")}.png`;

                  e.target.onerror = null;
                }}
              />
            </li>
          ))}
        </ul>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="partner-banks-loader">
        <div className="partner-banks-spinner"></div>
        <p>Loading Banking Partners...</p>
      </div>
    );
  }

  return (
    <section className="partner-banks-section">
      <div className="partner-banks-header">
        <h2>Our 100+ Banking Partners</h2>
        <p>Trusted by India's Leading Financial Institutions</p>
      </div>

      <div className="partner-banks-container">
        {renderBankRow(bankRows.firstRow, 1)}
        {renderBankRow(bankRows.secondRow, 2)}
        {renderBankRow(bankRows.thirdRow, 3)}
      </div>
    </section>
  );
};

export default BankingPartnersSection;
